import {Notify} from "../utils/Notify";
import {Networking} from "../utils/Netwtorking";
import {ControlsGeneralMenuTopControl} from "../../../app/controls/General/MenuTopControl/MenuTopControl";
import {ControlsGeneralSideNavControl} from "../../../app/controls/General/SideNavControl/SideNavControl";
import {DOM} from "../utils/DOM";
import {SentryInit} from "../utils/Sentry/Sentry";
import {ControlsGeneralReportFeedbackControl} from "../../../app/controls/General/ReportFeedbackControl/ReportFeedbackControl";

export class PageLoader {

    public static initializePresenterPage(welcomePage: boolean = false) : void {

        // Initialize Sentry
        SentryInit();

        // Initialize flash messages using session
        Notify.Handler.processMessagesFromDOM();

        // We are on the new page, remove old network requests
        Networking.NetworkingController.removeRequests();

        // If not on welcome page, then initialize triggers on layout
        if (!welcomePage) {
            ControlsGeneralMenuTopControl.Control.triggerToggleMenu();
            ControlsGeneralSideNavControl.Control.triggerToggleMenu();
            ControlsGeneralReportFeedbackControl.Control.initialize();
            this.initRedirectTriggers();
        }
    }

    private static initRedirectTriggers() : void {

        const redirectElements = DOM.Parser.getElementsByDataName('redirect-url', undefined, true);
        for (let i = 0; i < redirectElements.length; i++) {
            redirectElements[i].addEventListener('click', () => {
                window.location.href = DOM.Parser.getDataByNameFromElement('redirectUrl', redirectElements[i]);
            })
        }
    }
}
